import { api } from "./client";
import type { DailyRewardClaimResult, DailyRewardStatus } from "../types";

export const dailyRewardApi = {
  getStatus: () => api.get<DailyRewardStatus>("/daily-reward/status"),
  claim: () => api.post<DailyRewardClaimResult>("/daily-reward/claim"),
};
